import { render } from "./index.vue?vue&type=template&id=aaabca6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=aaabca6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aaabca6a"

export default script